export default "__VITE_ASSET__3c59c47b__"